import { Injectable } from '@angular/core';
import { finalize, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  isLoading = new Subject<boolean>();

  constructor() { }

  show(loadingSubject?: Subject<boolean>) {
    if (loadingSubject) {
      return loadingSubject.next(true);
    }
    this.isLoading.next(true);
  }
  hide(loadingSubject?: Subject<boolean>) {
    if (loadingSubject) {
      return loadingSubject.next(false);
    }

    this.isLoading.next(false);
  }

  executeWithLoader<T>(
    observable: Observable<T>,
    loadingSubject?: Subject<boolean>,
  ) {

    this.show(loadingSubject);
    return observable.pipe(
      finalize(() => {
        this.hide(loadingSubject);
      }),
    );
  }
}
